/* Countdown timers: [data-hw-end] is the Halloween countdown, [data-lo-end] the launch offer. Each timer hides its own call to action at zero. */
(function () {
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
  function fill(el, left) {
    var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
    if (el.getAttribute('data-hw-style') === 'tiles') {
      el.innerHTML = [[d, 'days'], [h, 'hours'], [m, 'min'], [s, 'sec']].map(function (t) {
        return '<div class="hwb__tile"><b>' + pad(t[0]) + '</b><span>' + t[1] + '</span></div>';
      }).join('');
    } else if (el.getAttribute('data-hw-style') === 'compact') {
      // under a day: a running clock with seconds (2:18:05, or 18:05 in the last hour)
      el.textContent = d > 0 ? d + 'd ' + h + 'h' : (h > 0 ? h + ':' + pad(m) + ':' + pad(s) : pad(m) + ':' + pad(s));
    } else {
      el.textContent = d > 0 ? d + 'd ' + h + 'h ' + pad(m) + 'm' : h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    return d;
  }
  // The daily flash deal resets at midnight. When the deal on screen ends, fetch the page again in the background and swap in the new
  // deal pill (new products, new % and a new countdown), or hide it if no deal is live. No page reload, so a bag being built is never lost.
  var swapping = false, doneEnds = {};
  function flashEnded(oldEnd) {
    if (swapping || doneEnds[oldEnd]) return;
    swapping = true;
    var tries = 0;
    (function attempt() {
      tries++;
      fetch(location.pathname + (location.search ? location.search + '&' : '?') + 'fd=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('details[data-fd-pill]');
          var t = fresh && fresh.querySelector('[data-lo-end]');
          var newEnd = t ? Number(t.getAttribute('data-lo-end')) : 0;
          if (fresh && newEnd * 1000 > Date.now() && newEnd !== oldEnd / 1000) {
            var cur = document.querySelector('details[data-fd-pill]');
            if (cur) cur.replaceWith(fresh);
            else { var cart = document.getElementById('cart-icon-bubble'); if (cart && cart.parentNode) cart.parentNode.insertBefore(fresh, cart); }
            document.body.classList.remove('lo-ended');
            doneEnds[oldEnd] = true; swapping = false;
          } else if (tries < 6) { setTimeout(attempt, tries < 3 ? 4000 : 20000); }
          else { doneEnds[oldEnd] = true; swapping = false; }
        })
        .catch(function () { if (tries < 6) setTimeout(attempt, 20000); else { doneEnds[oldEnd] = true; swapping = false; } });
    })();
  }
  function render() {
    var now = Date.now();
    var flashLeft = Infinity;
    document.querySelectorAll('[data-hw-end],[data-lo-end]').forEach(function (el) {
      var isLo = el.hasAttribute('data-lo-end');
      var end = Number(el.getAttribute(isLo ? 'data-lo-end' : 'data-hw-end')) * 1000;
      var left = Math.floor((end - now) / 1000);
      if (!end || left <= 0) { document.body.classList.add(isLo ? 'lo-ended' : 'hw-ended'); if (isLo && end) flashEnded(end); return; }
      var d = fill(el, left);
      if (isLo && left < flashLeft) flashLeft = left;
      if (d === 0 && !isLo) document.body.classList.add('hw-last-day');
    });
    // the last hour of a flash deal: the header pill turns hot pink so it is hard to miss
    document.body.classList.toggle('fd-urgent', flashLeft < 3600);
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-fd-pill][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-fd-open]');
    if (!chip) return;
    e.preventDefault();
    var drawer = chip.closest('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    var pill = document.querySelector('details[data-fd-pill]');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (pill) setTimeout(function () { pill.setAttribute('open', ''); }, 300);
  });
  setInterval(render, 1000);
  render();
})();
